export const isFromButton = (event) => event?.target?.type === 'button';
export const isZoomIn = (val = 120) => Math.floor(
  (window.outerWidth / window.innerWidth) * 100
) >= val - 5;
